module.exports = __webpack_public_path__ + "img/gg.8eb98039.svg";